/**
 * 그룹 대화방 자동 이름 나열 — server/utils/groupName.js `formatGroupName`의 사본.
 *
 * 화면에 보이는 자동 이름은 서버가 보는 사람마다 계산해서 내려준다(`Channel.nameAuto`). 이 사본은
 * 대화방 개설 창의 미리보기와, 구서버 호환용으로 함께 보내는 이름에만 쓴다.
 *
 * ⚠ import를 넣지 말 것 — scripts/test-group-name.js가 transpile해 서버판과 결과를 대조한다.
 *   규칙을 바꾸면 server/utils/groupName.js도 같이 고친다.
 */

/** src/types.ts CHANNEL_NAME_MAX_LEN과 같은 값(테스트가 확인한다) */
export const GROUP_NAME_MAX_LEN = 50;

export function formatGroupName(
  names: string[],
  opts: { total?: number; maxLen?: number } = {}
): string {
  const maxLen = opts.maxLen || GROUP_NAME_MAX_LEN;
  const list = (names || []).map((n) => String(n == null ? '' : n).trim()).filter(Boolean);
  const total = Math.max(
    typeof opts.total === 'number' && Number.isFinite(opts.total) ? opts.total : list.length,
    list.length
  );
  if (list.length === 0) return total > 0 ? `${total}명` : '';

  const full = list.join(', ');
  if (total === list.length && full.length <= maxLen) return full;

  let included = '';
  let count = 0;
  for (let i = 0; i < list.length; i++) {
    const candidate = included ? `${included}, ${list[i]}` : list[i];
    const remaining = total - (i + 1);
    const suffix = remaining > 0 ? ` 외 ${remaining}명` : '';
    if ((candidate + suffix).length > maxLen) break;
    included = candidate;
    count = i + 1;
  }
  if (count === 0) {
    // 첫 이름만으로도 넘치는 극단 케이스: 이름을 잘라서라도 맞춘다
    const remaining = total - 1;
    const suffix = remaining > 0 ? ` 외 ${remaining}명` : '';
    return list[0].slice(0, Math.max(1, maxLen - suffix.length - 1)) + '…' + suffix;
  }
  const rest = total - count;
  return rest > 0 ? `${included} 외 ${rest}명` : included;
}
